<template>
  <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button class="layout-menu-button layout-topbar-action" @click="toggleMenu">
        <i class="pi pi-bars"></i>
      </button>
      <router-link to="/" class="layout-topbar-logo">
        <span>Mos Health Dashboard</span>
      </router-link>
    </div>

    <div class="layout-topbar-actions">
      <!-- Active org context -->
      <div v-if="activeOrganization && isOnOrgRoute" class="flex items-center gap-2 px-3 py-1 rounded-lg text-sm" style="background-color: var(--mos-peach); color: var(--mos-brown-dark)">
        <i class="pi pi-building"></i>
        <span class="font-medium">{{ activeOrganization.name }}</span>
        <router-link
          v-if="isSuperAdmin"
          to="/super-admin"
          class="ml-1 underline hover:no-underline"
          style="color: var(--mos-brown)"
        >
          Back to SA Panel
        </router-link>
        <router-link
          v-else-if="organizations.length > 1"
          to="/"
          class="ml-1 underline hover:no-underline"
          style="color: var(--mos-brown)"
        >
          Switch
        </router-link>
      </div>

      <span v-if="user?.email" class="hidden md:flex items-center text-sm" style="color: var(--mos-text-muted)">
        {{ user.email }}
      </span>

      <button type="button" class="layout-topbar-action" @click="toggleDarkMode">
        <i :class="['pi', { 'pi-moon': isDarkTheme, 'pi-sun': !isDarkTheme }]"></i>
      </button>

      <router-link to="/account" class="layout-topbar-action">
        <i class="pi pi-user"></i>
      </router-link>

      <button type="button" class="layout-topbar-action" @click="handleLogout" v-tooltip="'Log out'">
        <i class="pi pi-sign-out"></i>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLayout } from '@/layout/composables/layout.ts'
import { useUserStore } from '@/stores/user.ts'
import { useOrganizationsStore } from '@/stores/organizations.ts'
import { useSuperAdmin } from '@/composables/use-super-admin'
import { useOrgRouteContext } from '@/composables/use-org-route-context'
import { storeToRefs } from 'pinia'

const { toggleMenu, toggleDarkMode, isDarkTheme } = useLayout()
const userStore = useUserStore()
const { user } = storeToRefs(userStore)
const orgStore = useOrganizationsStore()
const { activeOrganization, organizations } = storeToRefs(orgStore)
const { isSuperAdmin } = useSuperAdmin()
const { isOnOrgRoute } = useOrgRouteContext()

const handleLogout = async () => {
  try {
    await userStore.logout()
  } catch (e) {
    console.error('Error logging out:', e)
  }
}
</script>
